/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Api
 * Project Nomad API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthInput,
  Company,
  CompanyInput,
  CompanyUpdate,
  DashboardSummary,
  ErrorResponse,
  GreenDayStatus,
  HealthStatus,
  IncomeEntry,
  IncomeInput,
  IncomeUpdate,
  ListIncomeParams,
  ListOpportunitiesParams,
  Opportunity,
  OpportunityInput,
  OpportunityUpdate,
  Settings,
  SettingsUpdate,
  SuccessResponse,
  Timer,
  TimerInput,
  TimerResponse,
  TodayIncomeSummary,
  User
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRegisterUrl = () => {




  return `/api/auth/register`
}

/**
 * @summary Register a new user
 */
export const register = async (authInput: AuthInput, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authInput)
  }
);}





export const getRegisterMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<AuthInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<AuthInput>}, TContext> => {

const mutationKey = ['register'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, {data: BodyType<AuthInput>}> = (props) => {
          const {data} = props ?? {};

          return  register(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = BodyType<AuthInput>
    export type RegisterMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Register a new user
 */
export const useRegister = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: BodyType<AuthInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        {data: BodyType<AuthInput>},
        TContext
      > => {
      return useMutation(getRegisterMutationOptions(options));
    }

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Login
 */
export const login = async (authInput: AuthInput, options?: RequestInit): Promise<User> => {

  return customFetch<User>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(authInput)
  }
);}





export const getLoginMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<AuthInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<AuthInput>}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: BodyType<AuthInput>}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = BodyType<AuthInput>
    export type LoginMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Login
 */
export const useLogin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: BodyType<AuthInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: BodyType<AuthInput>},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options));
    }

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Logout
 */
export const logout = async ( options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<unknown>

    /**
 * @summary Logout
 */
export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Get current user
 */
export const getMe = async ( options?: RequestInit): Promise<User> => {

  return customFetch<User>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDashboardSummaryUrl = () => {




  return `/api/dashboard/summary`
}

/**
 * @summary Get mission dashboard summary
 */
export const getDashboardSummary = async ( options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = () => {
    return [
    `/api/dashboard/summary`
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get mission dashboard summary
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCurrentTimerUrl = () => {




  return `/api/timer/current`
}

/**
 * @summary Get current running timer
 */
export const getCurrentTimer = async ( options?: RequestInit): Promise<TimerResponse> => {

  return customFetch<TimerResponse>(getGetCurrentTimerUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentTimerQueryKey = () => {
    return [
    `/api/timer/current`
    ] as const;
    }


export const getGetCurrentTimerQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentTimer>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTimer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentTimerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentTimer>>> = ({ signal }) => getCurrentTimer({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentTimer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentTimerQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentTimer>>>
export type GetCurrentTimerQueryError = ErrorType<unknown>


/**
 * @summary Get current running timer
 */

export function useGetCurrentTimer<TData = Awaited<ReturnType<typeof getCurrentTimer>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTimer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentTimerQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartTimerUrl = () => {




  return `/api/timer/start`
}

/**
 * @summary Start the mission timer
 */
export const startTimer = async (timerInput: TimerInput, options?: RequestInit): Promise<Timer> => {

  return customFetch<Timer>(getStartTimerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(timerInput)
  }
);}





export const getStartTimerMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTimer>>, TError,{data: BodyType<TimerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startTimer>>, TError,{data: BodyType<TimerInput>}, TContext> => {

const mutationKey = ['startTimer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startTimer>>, {data: BodyType<TimerInput>}> = (props) => {
          const {data} = props ?? {};

          return  startTimer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartTimerMutationResult = NonNullable<Awaited<ReturnType<typeof startTimer>>>
    export type StartTimerMutationBody = BodyType<TimerInput>
    export type StartTimerMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Start the mission timer
 */
export const useStartTimer = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTimer>>, TError,{data: BodyType<TimerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startTimer>>,
        TError,
        {data: BodyType<TimerInput>},
        TContext
      > => {
      return useMutation(getStartTimerMutationOptions(options));
    }

export const getStopTimerUrl = () => {




  return `/api/timer/stop`
}

/**
 * @summary Stop the current timer
 */
export const stopTimer = async ( options?: RequestInit): Promise<Timer> => {

  return customFetch<Timer>(getStopTimerUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStopTimerMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopTimer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stopTimer>>, TError,void, TContext> => {

const mutationKey = ['stopTimer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stopTimer>>, void> = () => {


          return  stopTimer(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StopTimerMutationResult = NonNullable<Awaited<ReturnType<typeof stopTimer>>>

    export type StopTimerMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Stop the current timer
 */
export const useStopTimer = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopTimer>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof stopTimer>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStopTimerMutationOptions(options));
    }

export const getListIncomeUrl = (params?: ListIncomeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/income?${stringifiedParams}` : `/api/income`
}

/**
 * @summary List income entries
 */
export const listIncome = async (params?: ListIncomeParams, options?: RequestInit): Promise<IncomeEntry[]> => {

  return customFetch<IncomeEntry[]>(getListIncomeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListIncomeQueryKey = (params?: ListIncomeParams,) => {
    return [
    `/api/income`, ...(params ? [params] : [])
    ] as const;
    }


export const getListIncomeQueryOptions = <TData = Awaited<ReturnType<typeof listIncome>>, TError = ErrorType<unknown>>(params?: ListIncomeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIncome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIncomeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIncome>>> = ({ signal }) => listIncome(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIncome>>, TError, TData> & { queryKey: QueryKey }
}

export type ListIncomeQueryResult = NonNullable<Awaited<ReturnType<typeof listIncome>>>
export type ListIncomeQueryError = ErrorType<unknown>


/**
 * @summary List income entries
 */

export function useListIncome<TData = Awaited<ReturnType<typeof listIncome>>, TError = ErrorType<unknown>>(
 params?: ListIncomeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listIncome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListIncomeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateIncomeEntryUrl = () => {




  return `/api/income`
}

/**
 * @summary Log an income entry
 */
export const createIncomeEntry = async (incomeInput: IncomeInput, options?: RequestInit): Promise<IncomeEntry> => {

  return customFetch<IncomeEntry>(getCreateIncomeEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(incomeInput)
  }
);}





export const getCreateIncomeEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIncomeEntry>>, TError,{data: BodyType<IncomeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createIncomeEntry>>, TError,{data: BodyType<IncomeInput>}, TContext> => {

const mutationKey = ['createIncomeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIncomeEntry>>, {data: BodyType<IncomeInput>}> = (props) => {
          const {data} = props ?? {};

          return  createIncomeEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateIncomeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createIncomeEntry>>>
    export type CreateIncomeEntryMutationBody = BodyType<IncomeInput>
    export type CreateIncomeEntryMutationError = ErrorType<unknown>

    /**
 * @summary Log an income entry
 */
export const useCreateIncomeEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIncomeEntry>>, TError,{data: BodyType<IncomeInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createIncomeEntry>>,
        TError,
        {data: BodyType<IncomeInput>},
        TContext
      > => {
      return useMutation(getCreateIncomeEntryMutationOptions(options));
    }

export const getGetTodayIncomeUrl = () => {




  return `/api/income/today`
}

/**
 * @summary Get today's income total and entries
 */
export const getTodayIncome = async ( options?: RequestInit): Promise<TodayIncomeSummary> => {

  return customFetch<TodayIncomeSummary>(getGetTodayIncomeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTodayIncomeQueryKey = () => {
    return [
    `/api/income/today`
    ] as const;
    }


export const getGetTodayIncomeQueryOptions = <TData = Awaited<ReturnType<typeof getTodayIncome>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTodayIncome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTodayIncomeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTodayIncome>>> = ({ signal }) => getTodayIncome({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTodayIncome>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTodayIncomeQueryResult = NonNullable<Awaited<ReturnType<typeof getTodayIncome>>>
export type GetTodayIncomeQueryError = ErrorType<unknown>


/**
 * @summary Get today's income total and entries
 */

export function useGetTodayIncome<TData = Awaited<ReturnType<typeof getTodayIncome>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTodayIncome>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTodayIncomeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateIncomeEntryUrl = (id: number,) => {




  return `/api/income/${id}`
}

/**
 * @summary Update an income entry
 */
export const updateIncomeEntry = async (id: number,
    incomeUpdate: IncomeUpdate, options?: RequestInit): Promise<IncomeEntry> => {

  return customFetch<IncomeEntry>(getUpdateIncomeEntryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(incomeUpdate)
  }
);}





export const getUpdateIncomeEntryMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIncomeEntry>>, TError,{id: number;data: BodyType<IncomeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIncomeEntry>>, TError,{id: number;data: BodyType<IncomeUpdate>}, TContext> => {

const mutationKey = ['updateIncomeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIncomeEntry>>, {id: number;data: BodyType<IncomeUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateIncomeEntry(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateIncomeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof updateIncomeEntry>>>
    export type UpdateIncomeEntryMutationBody = BodyType<IncomeUpdate>
    export type UpdateIncomeEntryMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update an income entry
 */
export const useUpdateIncomeEntry = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIncomeEntry>>, TError,{id: number;data: BodyType<IncomeUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateIncomeEntry>>,
        TError,
        {id: number;data: BodyType<IncomeUpdate>},
        TContext
      > => {
      return useMutation(getUpdateIncomeEntryMutationOptions(options));
    }

export const getDeleteIncomeEntryUrl = (id: number,) => {




  return `/api/income/${id}`
}

/**
 * @summary Delete an income entry
 */
export const deleteIncomeEntry = async (id: number, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteIncomeEntryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteIncomeEntryMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIncomeEntry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIncomeEntry>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteIncomeEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIncomeEntry>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteIncomeEntry(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteIncomeEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIncomeEntry>>>

    export type DeleteIncomeEntryMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete an income entry
 */
export const useDeleteIncomeEntry = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIncomeEntry>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteIncomeEntry>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteIncomeEntryMutationOptions(options));
    }

export const getListCompaniesUrl = () => {




  return `/api/companies`
}

/**
 * @summary List tracked companies
 */
export const listCompanies = async ( options?: RequestInit): Promise<Company[]> => {

  return customFetch<Company[]>(getListCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCompaniesQueryKey = () => {
    return [
    `/api/companies`
    ] as const;
    }


export const getListCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanies>>> = ({ signal }) => listCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listCompanies>>>
export type ListCompaniesQueryError = ErrorType<unknown>


/**
 * @summary List tracked companies
 */

export function useListCompanies<TData = Awaited<ReturnType<typeof listCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCompanyUrl = () => {




  return `/api/companies`
}

/**
 * @summary Add a company to track
 */
export const createCompany = async (companyInput: CompanyInput, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getCreateCompanyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyInput)
  }
);}





export const getCreateCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext> => {

const mutationKey = ['createCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompany>>, {data: BodyType<CompanyInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCompany(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createCompany>>>
    export type CreateCompanyMutationBody = BodyType<CompanyInput>
    export type CreateCompanyMutationError = ErrorType<unknown>

    /**
 * @summary Add a company to track
 */
export const useCreateCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CompanyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCompany>>,
        TError,
        {data: BodyType<CompanyInput>},
        TContext
      > => {
      return useMutation(getCreateCompanyMutationOptions(options));
    }

export const getGetCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Get a company by ID
 */
export const getCompany = async (id: number, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getGetCompanyUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCompanyQueryKey = (id: number,) => {
    return [
    `/api/companies/${id}`
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a company by ID
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Update a company
 */
export const updateCompany = async (id: number,
    companyUpdate: CompanyUpdate, options?: RequestInit): Promise<Company> => {

  return customFetch<Company>(getUpdateCompanyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(companyUpdate)
  }
);}





export const getUpdateCompanyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {id: number;data: BodyType<CompanyUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompany(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = BodyType<CompanyUpdate>
    export type UpdateCompanyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a company
 */
export const useUpdateCompany = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<CompanyUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {id: number;data: BodyType<CompanyUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCompanyMutationOptions(options));
    }

export const getDeleteCompanyUrl = (id: number,) => {




  return `/api/companies/${id}`
}

/**
 * @summary Delete a company
 */
export const deleteCompany = async (id: number, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteCompanyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCompanyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompany>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompany(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompany>>>

    export type DeleteCompanyMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a company
 */
export const useDeleteCompany = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompany>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCompanyMutationOptions(options));
    }

export const getGetGreenDayStatusUrl = () => {




  return `/api/green-day/status`
}

/**
 * @summary Get today's green day status
 */
export const getGreenDayStatus = async ( options?: RequestInit): Promise<GreenDayStatus> => {

  return customFetch<GreenDayStatus>(getGetGreenDayStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGreenDayStatusQueryKey = () => {
    return [
    `/api/green-day/status`
    ] as const;
    }


export const getGetGreenDayStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGreenDayStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGreenDayStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGreenDayStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGreenDayStatus>>> = ({ signal }) => getGreenDayStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGreenDayStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGreenDayStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGreenDayStatus>>>
export type GetGreenDayStatusQueryError = ErrorType<unknown>


/**
 * @summary Get today's green day status
 */

export function useGetGreenDayStatus<TData = Awaited<ReturnType<typeof getGreenDayStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGreenDayStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGreenDayStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListOpportunitiesUrl = (params?: ListOpportunitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/opportunities?${stringifiedParams}` : `/api/opportunities`
}

/**
 * @summary List opportunities
 */
export const listOpportunities = async (params?: ListOpportunitiesParams, options?: RequestInit): Promise<Opportunity[]> => {

  return customFetch<Opportunity[]>(getListOpportunitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpportunitiesQueryKey = (params?: ListOpportunitiesParams,) => {
    return [
    `/api/opportunities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof listOpportunities>>, TError = ErrorType<unknown>>(params?: ListOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpportunitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpportunities>>> = ({ signal }) => listOpportunities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpportunities>>>
export type ListOpportunitiesQueryError = ErrorType<unknown>


/**
 * @summary List opportunities
 */

export function useListOpportunities<TData = Awaited<ReturnType<typeof listOpportunities>>, TError = ErrorType<unknown>>(
 params?: ListOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpportunitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOpportunityUrl = () => {




  return `/api/opportunities`
}

/**
 * @summary Create an opportunity
 */
export const createOpportunity = async (opportunityInput: OpportunityInput, options?: RequestInit): Promise<Opportunity> => {

  return customFetch<Opportunity>(getCreateOpportunityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(opportunityInput)
  }
);}





export const getCreateOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,{data: BodyType<OpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,{data: BodyType<OpportunityInput>}, TContext> => {

const mutationKey = ['createOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpportunity>>, {data: BodyType<OpportunityInput>}> = (props) => {
          const {data} = props ?? {};

          return  createOpportunity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof createOpportunity>>>
    export type CreateOpportunityMutationBody = BodyType<OpportunityInput>
    export type CreateOpportunityMutationError = ErrorType<unknown>

    /**
 * @summary Create an opportunity
 */
export const useCreateOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,{data: BodyType<OpportunityInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpportunity>>,
        TError,
        {data: BodyType<OpportunityInput>},
        TContext
      > => {
      return useMutation(getCreateOpportunityMutationOptions(options));
    }

export const getUpdateOpportunityUrl = (id: number,) => {




  return `/api/opportunities/${id}`
}

/**
 * @summary Update an opportunity
 */
export const updateOpportunity = async (id: number,
    opportunityUpdate: OpportunityUpdate, options?: RequestInit): Promise<Opportunity> => {

  return customFetch<Opportunity>(getUpdateOpportunityUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(opportunityUpdate)
  }
);}





export const getUpdateOpportunityMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,{id: number;data: BodyType<OpportunityUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,{id: number;data: BodyType<OpportunityUpdate>}, TContext> => {

const mutationKey = ['updateOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpportunity>>, {id: number;data: BodyType<OpportunityUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpportunity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpportunity>>>
    export type UpdateOpportunityMutationBody = BodyType<OpportunityUpdate>
    export type UpdateOpportunityMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update an opportunity
 */
export const useUpdateOpportunity = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,{id: number;data: BodyType<OpportunityUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpportunity>>,
        TError,
        {id: number;data: BodyType<OpportunityUpdate>},
        TContext
      > => {
      return useMutation(getUpdateOpportunityMutationOptions(options));
    }

export const getDeleteOpportunityUrl = (id: number,) => {




  return `/api/opportunities/${id}`
}

/**
 * @summary Delete an opportunity
 */
export const deleteOpportunity = async (id: number, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getDeleteOpportunityUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOpportunityMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpportunity>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOpportunity(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpportunity>>>

    export type DeleteOpportunityMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete an opportunity
 */
export const useDeleteOpportunity = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpportunity>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteOpportunityMutationOptions(options));
    }

export const getGetSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Get user settings
 */
export const getSettings = async ( options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getGetSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = () => {
    return [
    `/api/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get user settings
 */

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Update user settings
 */
export const updateSettings = async (settingsUpdate: SettingsUpdate, options?: RequestInit): Promise<Settings> => {

  return customFetch<Settings>(getUpdateSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(settingsUpdate)
  }
);}





export const getUpdateSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {data: BodyType<SettingsUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = BodyType<SettingsUpdate>
    export type UpdateSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update user settings
 */
export const useUpdateSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<SettingsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {data: BodyType<SettingsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options));
    }

